import { redirect } from "react-router-dom";
import store from "./store";
export const isLoggedInLoader = async (
  userToken: string | null
): Promise<null> => {
  const state = store.getState() as any;
  const reduxToken = state.auth?.accessToken;
  const token = userToken || reduxToken;

  if (!token) {
    sessionStorage.setItem("redirectUrl", window.location.href);
    throw redirect("/login");
  }

  //Logged in — proceed normally
  return null;
};
